import { render } from "./ArtistDetail.vue?vue&type=template&id=9fee865a&scoped=true"
import script from "./ArtistDetail.vue?vue&type=script&lang=js"
export * from "./ArtistDetail.vue?vue&type=script&lang=js"

import "./ArtistDetail.vue?vue&type=style&index=0&id=9fee865a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fee865a"]])

export default __exports__